export default class NavigateConst{
    static To_Login(): string {
        return '/login'
    }
    
    static To_Home=()=>{
        return "/"
    }
}